import { injectAPISession } from '@monofe/apiservice';
import { IRouteTourArguments, ISiteObjectSelectControllerRenderResult } from './interface';

function CanRender(route: IRouteTourArguments): Promise<ISiteObjectSelectControllerRenderResult> {
    return new Promise(async function (resolve, reject) {
        try {
            const workspace = await injectAPISession().open(route.sessionName);

            await workspace.db.open();

            const tour = await workspace.db.get('ITourDto', route.tourId);

            const allTourRelatedSiteObjects = await workspace.db.all('ITourRelatedSiteObjectDto');
            const matchingTourRelatedSiteObjects = allTourRelatedSiteObjects.filter(
                x => x.tourId === tour.id,
            );

            const hasMultipleSiteObjects = matchingTourRelatedSiteObjects.length > 1;

            let result: ISiteObjectSelectControllerRenderResult = {
                hasEnoughDataToRender: hasMultipleSiteObjects,
            };

            if (matchingTourRelatedSiteObjects.length <= 0) {
                throw Error('‘No site-objects found. Unable to launch tour');
            }

            if (!result.hasEnoughDataToRender) {
                result = {
                    ...result,
                    suggestedAlternativeRoute: 'SiteObject',
                    additionalRouteDataNeeded: {
                        ...route,
                        siteObjectId: matchingTourRelatedSiteObjects[0].siteObjectId,
                    },
                };
            }

            resolve(result);
        } catch (error) {
            reject(error);
        }
    });
}

export default CanRender;
